<template>
    <div class="dynamic-crf-wrapper">
        <v-container fill-height>
            <v-layout column>
                <v-snackbar :color="wizSnackbarColor"
                            v-model="wizSnackbarShow"
                            :timeout="wizSnackbarTimeout"
                            :vertical="wizSnackbarStacked"
                            top>
                    <div v-html="wizSnackbarText"></div>
                    <v-btn text
                           class="white error"
                           @click.native="wizSnackbarShow = false">Close</v-btn>
                </v-snackbar>
                <div class="dynamic-crf-wiz-wrapper">
                    <v-form ref="dynamicForm" v-model="formValid" @submit.prevent>
                        <template v-for="(item, index) in getCurrentPageItems()">
                            <template v-if="item.itemType == 'section-instruction'">
                                <div v-html="item.sectionTitle"
                                     class="dynamic-crf-section-instruction title"
                                     :key="index"></div>
                            </template>
                            <template v-if="item.itemType == 'data-item'">
                                <div class="dynamic-crf-question-wrapper py-4"
                                     :class="classDynamicCrfQuestionSeparator"
                                     :key="index">
                                    <v-container>
                                        <v-row no-gutters>
                                            <v-col cols="12" md="6">
                                                <div class="dynamic-crf-question-label mb-4">
                                                    <label :for="`id_${item.dataItemId}`"
                                                           v-html="item.controlCaption"></label>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <div class="dynamic-crf-question-answer-options px-3">
                                                    <answer-options-sm v-if="item.hasLookUpTable && $vuetify.breakpoint.smAndDown"
                                                                       :id="`id_${item.dataItemId}`"
                                                                       :ref="item.dataItemId"
                                                                       @change="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                       :options="item.lookUpTable"
                                                                       :required="item.lookupIsRequired"
                                                                       :dataItemId="item.dataItemId"
                                                                       v-model="item.dataItemValue"
                                                                       :controlDisabled="!item.controlEnabled"></answer-options-sm>
                                                    <v-select v-if="item.hasLookUpTable && $vuetify.breakpoint.mdAndUp"
                                                              :id="`id_${item.dataItemId}`"
                                                              :ref="item.dataItemId"
                                                              v-model="item.dataItemValue"
                                                              :rules="item.validationRules"
                                                              :items="item.lookUpTable"
                                                              @change="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                              item-text="text"
                                                              item-value="value"
                                                              outlined
                                                              clearable
                                                              :disabled="!item.controlEnabled"
                                                              :error="item.customError"
                                                              :error-messages="item.customErrorMessage"></v-select>
                                                    <v-text-field v-if="item.itemType == 'data-item' && item.dataType.endsWith('varchar') && item.length &lt;= 200"
                                                                  :id="`id_${item.dataItemId}`"
                                                                  :ref="item.dataItemId"
                                                                  @change="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                  @click:clear="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                  outlined
                                                                  clearable
                                                                  :inputmode="item.inputmode"
                                                                  :prefix="item.prefix"
                                                                  :suffix="item.suffix"
                                                                  :maxlength="item.length"
                                                                  :rules="item.validationRules"
                                                                  v-model.trim="item.dataItemValue"
                                                                  :disabled="!item.controlEnabled"
                                                                  :error="item.customError"
                                                                  :error-messages="item.customErrorMessage"></v-text-field>
                                                    <v-textarea v-if="item.itemType == 'data-item' && item.dataType.endsWith('varchar') && item.length &gt; 200"
                                                                :id="`id_${item.dataItemId}`"
                                                                :ref="item.dataItemId"
                                                                @change="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                @click:clear="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                outlined
                                                                clearable
                                                                auto-grow
                                                                :inputmode="item.inputmode"
                                                                :prefix="item.prefix"
                                                                :suffix="item.suffix"
                                                                :maxlength="item.length"
                                                                :rules="item.validationRules"
                                                                v-model.trim="item.dataItemValue"
                                                                :disabled="!item.controlEnabled"
                                                                :error="item.customError"
                                                                :error-messages="item.customErrorMessage"></v-textarea>
                                                    <v-text-field v-if="item.itemType == 'data-item' && item.dataType.includes('int') && !item.hasLookUpTable"
                                                                  :id="`id_${item.dataItemId}`"
                                                                  :ref="item.dataItemId"
                                                                  @change="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                  @click:clear="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                  outlined
                                                                  clearable
                                                                  maxlength="10"
                                                                  :inputmode="item.inputmode"
                                                                  :prefix="item.prefix"
                                                                  :suffix="item.suffix"
                                                                  :rules="item.validationRules"
                                                                  v-model.trim="item.dataItemValue"
                                                                  :disabled="!item.controlEnabled"
                                                                  :error="item.customError"
                                                                  :error-messages="item.customErrorMessage"></v-text-field>
                                                    <v-text-field v-if="item.itemType == 'data-item' && item.dataType == 'decimal'"
                                                                  :id="`id_${item.dataItemId}`"
                                                                  :ref="item.dataItemId"
                                                                  @change="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                  @click:clear="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                  outlined
                                                                  clearable
                                                                  maxlength="10"
                                                                  :inputmode="item.inputmode"
                                                                  :prefix="item.prefix"
                                                                  :suffix="item.suffix"
                                                                  :rules="item.validationRules"
                                                                  v-model.trim="item.dataItemValue"
                                                                  :disabled="!item.controlEnabled"
                                                                  :error="item.customError"
                                                                  :error-messages="item.customErrorMessage"></v-text-field>
                                                    <custom-date-picker v-if="item.itemType == 'data-item' && item.dataType.includes('date')"
                                                                        :id="`id_${item.dataItemId}`"
                                                                        :ref="item.dataItemId"
                                                                        @input="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                        v-model="item.dataItemValue"
                                                                        :required="item.dateIsRequired"
                                                                        :dataItemId="item.dataItemId"
                                                                        :controlDisabled="!item.controlEnabled"
                                                                        :rules="item.validationRules"
                                                                        :minAge="item.minAge"
                                                                        :maxAge="item.maxAge"
                                                                        :error="item.customError"
                                                                        :error-messages="item.customErrorMessage"></custom-date-picker>
                                                    <lookup-service-places v-if="item.itemType == 'data-item' &&(item.dataType == 'trialPlaceNames' || item.dataType == 'placeNamesByType')"
                                                                           :id="`id_${item.dataItemId}`"
                                                                           :ref="item.dataItemId"
                                                                           @input="dataItemChanged(item.dataItemId,item.dataItemValue)"
                                                                           v-model="item.dataItemValue"
                                                                           :required="item.lookupServiceIsRequired"
                                                                           :placeType="item.lookupServicePlaceType"
                                                                           :dataItemId="item.dataItemId"
                                                                           :controlDisabled="!item.controlEnabled"
                                                                           :error="item.customError"
                                                                           :error-messages="item.customErrorMessage"></lookup-service-places>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>
                            </template>
                        </template>
                    </v-form>
                    <v-footer v-if="showScrollIndicator" fixed inset app style="padding:0px">
                        <v-layout row wrap justify-center>
                            <div style="position: fixed;margin-left: auto;background:rgba(255,208,0,0.90);color:#000000" :style="{bottom:getFooterHeight()+'px'}">
                                <v-icon class="eq5d-vas-pointer-arrow-down">mdi-arrow-down</v-icon>Scroll for more<v-icon class="eq5d-vas-pointer-arrow-down">mdi-arrow-down</v-icon>
                            </div>
                        </v-layout>
                    </v-footer>
                    <v-footer :height="getFooterHeight()" color="primary" fixed inset app>
                        <v-layout row justify-center>
                            <v-flex xs12 class="dynamic-crf-nav-wrapper">
                                <v-btn @click="prevButton_onClick"
                                       class="dynamic-crf-footer-btn success"
                                       small>
                                    <v-icon left>mdi-chevron-left</v-icon>Previous
                                </v-btn>

                                <v-chip class="primary--text subtitle-2">{{ getCurrentPageNumber() }} of {{ getLastPageNumber() }}</v-chip>

                                <v-btn @click="nextButton_onClick"
                                       class="dynamic-crf-footer-btn success"
                                       small
                                       :loading="formSubmitBusy || formSavingBusy">
                                    {{ wizCurrentPage == getLastPageNumber() ? "Submit" : "Next" }}
                                    <v-icon right>mdi-chevron-right</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12>
                                <template v-if="getCurrentPageFooter()">
                                    <div class="eq5d-copyright primary body-2 white--text px-3 py-1" v-html="getCurrentPageFooter()"></div>
                                </template>
                            </v-flex>
                        </v-layout>
                    </v-footer>
                </div>
            </v-layout>
        </v-container>
        <v-dialog v-model="dlgInfo" persistent max-width="600px">
            <v-card>
                <v-card-title class="justify-center primary">
                    <span class="headline text-center white--text">INFORMATION</span>
                </v-card-title>
                <v-card-text class="text-left pt-4">
                    <span v-html="dlgMessage"
                          class="subtitle-1 dynamic-crf-info-dialog-text"></span>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn @click="closeInfoDialog"
                           :loading="formRedirectBusy"
                           class="primary mb-2"
                           width="100"
                           large>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dlgCustom.visible" persistent max-width="600px">
            <v-card>
                <v-card-title class="justify-center primary">
                    <span class="headline text-center white--text">{{ dlgCustom.title }}</span>
                </v-card-title>
                <v-card-text class="text-left pt-4">
                    <span v-html="dlgCustom.message"
                          class="subtitle-1 dynamic-crf-info-dialog-text"></span>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <template v-for="btn in dlgCustom.buttons">
                        <v-btn @click="btn.onClick.call(btn)"
                               class="primary mb-2"
                               width="100"
                               large
                               :key="btn.caption">{{ btn.caption }}</v-btn>
                    </template>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="formSubmitBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    {{ formSubmitBusyText }}
                    <v-progress-linear indeterminate
                                       color="white"
                                       class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar :value="getStepNotSavedMsg"
                    @input="setStepNotSavedMsg(false)"
                    color="error"
                    :timeout="10000"
                    top>
            <div>
                Form contains unsaved data, please click NEXT button to save your
                changes.
            </div>
            <v-btn text class="white error" @click.native="setStepNotSavedMsg(false)">Close</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    /* eslint-disable */
    import Vue from "vue";
    import { mapMutations, mapGetters } from "vuex";
    import axios from "axios";
    import moment from "moment";

    import {
        trialResourceAccount,
        create_crfs,
        updateTimepointText,
        applySkipLogic,
        getEndOfFormDialogHtml,
        numQuestionsPerPage,
        hideDisabledQuestions
    } from './DynamicCRF-generated';

    import { crfCallbacks } from '../handcrafted/CrfCallbacks';

    import { customValidation } from '../handcrafted/CustomValidation';

    export default {
        props: {
            crfId: {
                type: String,
                required: true,
            },
            crfTitle: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                baseUrl: "api/DynamicCrf/",

                crfs: create_crfs.call(this),
                dataItemMap: null,
                dlgCustom: Vue.observable({
                    visible: false,
                    show: function (title, message, buttons) {
                        this.visible = true;
                        this.title = title;
                        this.message = message;
                        this.buttons = buttons;
                    },
                    hide: function () {
                        this.visible = false;
                    }
                }),

                newPages: [],
                showScrollIndicator: false,

                wizCurrentPage: 1,
                isMobileMode: true,

                wizSnackbarShow: false,
                wizSnackbarText: "Form contains error(s), please check",
                wizSnackbarTimeout: 5000,
                wizSnackbarColor: "error",
                wizSnackbarStacked: false,

                formValid: true,
                formSubmitBusy: false,
                formSubmitBusyText: "",
                formRedirectBusy: false,
                formSavingBusy: false,
                formCompleteness: "",

                dlgInfo: false,
                dlgInfoOrigion: "",
                dlgMessage: "",
                dlgFormSubmitMessage: "",
                dlgFormSubmitTitle: "",
                dlgFormSubmitOrigion: "",
                dlgOnClose: null
            };
        },
        watch: {},
        methods: {
            ...mapMutations([
                "setCrfTitle",
                "setCurrentRoutePath",
                "setFormCompleteness",
                "clearErrors",
                "removeMenuItem",
                "clearFormAuthenticated",
                "clearFormGuid",
                "showMenuItems",
                "clearMenuItems",
                "setFormHasUnsavedChanges",
                "setStepNotSavedMsg",
                "setOnboardingFormData",
                "setDefaultPage",
                "resetDataEntry"
            ]),
            rebuildPages: function () {
                let crfItems = this.crfs[this.crfId].dataItems;

                let pages = [];
                function maybeAddPage(pageInfo) {
                    //ignore initial placeholder page
                    if (pageInfo.pageNumber == 0) return;
                    //a formGroup is the only thing on the page, and it has no caption. Omit the page.
                    if (pageInfo.items.length == 1 && pageInfo.items[0].itemType == 'section-instruction' && pageInfo.items[0].sectionTitle == '') return;
                    pages.push(pageInfo.items);
                }

                let pageInfo = {
                    pageNumber: 0,
                    firstPageSameGroup: 0,
                    maxQuestions: 0,
                    items: []
                };
                let defaultNumQuestionsPerPage = this.isMobileMode ? numQuestionsPerPage.inMobileMode : numQuestionsPerPage.inDesktopMode;

                let getPageSplit = (formGroupItem) => this.isMobileMode ? formGroupItem.pageSplitInMobileMode : formGroupItem.pageSplitInDesktopMode;

                function newPageSameGroup(items) {
                    let groupItem = pages[pageInfo.firstPageSameGroup - 1][0];
                    let pageSplit = getPageSplit(groupItem);
                    let pageNumber = 1 + pages.length;
                    let firstPageSameGroup = pageInfo.firstPageSameGroup;
                    return {
                        pageNumber, firstPageSameGroup, items,
                        maxQuestions: pageSplit ? pageSplit[pageNumber - firstPageSameGroup] : defaultNumQuestionsPerPage,
                    };
                }
                function newPageNewGroup(items) {
                    let groupItem = items[0];
                    let pageSplit = getPageSplit(groupItem);
                    let pageNumber = 1 + pages.length;
                    let firstPageSameGroup = pageNumber;
                    return {
                        pageNumber, firstPageSameGroup, items,
                        maxQuestions: pageSplit ? pageSplit[0] : defaultNumQuestionsPerPage,
                    };
                }
                crfItems.forEach((item, index) => {
                    if (item.itemType == 'section-instruction') {
                        maybeAddPage(pageInfo);
                        pageInfo = newPageNewGroup([item]);
                    } else if (pageInfo.items.length < 1 + pageInfo.maxQuestions) {
                        pageInfo.items.push(item);
                    } else {
                        maybeAddPage(pageInfo);
                        pageInfo = newPageSameGroup([pageInfo.items[0], item]);
                    }
                });
                maybeAddPage(pageInfo);

                let showDisabledDataItem = hideDisabledQuestions
                    ? (item) => false                       //hide all disabled questions
                    : (item) => !item.dependsOnTimepoint;   //hide only if disabled by timepoint (directly or indirectly)

                this.newPages = pages.filter(page =>
                    //filter out pages where all questions are disabled
                    page.length == 1 || page.find(it => it.itemType == 'data-item' && it.controlEnabled)
                ).map(page =>
                    page.filter(item =>
                        //filter out disabled questions
                        item.controlEnabled || item.itemType != 'data-item' || showDisabledDataItem(item)
                    )
                );
            },
            getCurrentPageItems: function () {
                return this.newPages[this.wizCurrentPage - 1];
            },
            findFirstEditableDataItem: function () {
                return this.getCurrentPageItems().find(item => item.itemType == 'data-item' && item.visible && item.controlEnabled);
            },
            getCurrentPageNumber: function () {
                return this.wizCurrentPage;
            },
            getLastPageNumber: function () {
                return this.newPages.length;
            },
            getCurrentPageFooter: function () {
                let items = this.getCurrentPageItems();
                let item0 = items ? items[0] : null;
                let footer = item0 ? item0.footer : '';
                return footer;
            },
            getFooterHeight: function () {
                const buttons = 50;
                const bottom_text = this.getCurrentPageFooter() ? 50 : 0;
                return buttons + bottom_text;
            },
            beginPost: function (url, payload, busy_text) {
                payload['pin'] = this.getDataEntryPin;
                this.formSubmitBusy = true;
                this.formSubmitBusyText = busy_text;
                return axios.post(url, payload);
            },
            endPost: function (result) {
                this.formSubmitBusy = false;
                this.formSubmitBusyText = '';
                return result;
            },
            goToURL(crf_url, default_page) {
                this.setDefaultPage(default_page);
                this.$router.push(crf_url);
            },
            validate: function () {
                if (!this.$refs.dynamicForm.validate())
                    return false;

                function validate_item(item) {
                    if (!(item.dataItemValue == 0 || item.dataItemValue) && (
                        item.lookupIsRequired ||
                        item.lookupServiceIsRequired ||
                        item.dateIsRequired
                    )) {
                        return false;
                    }
                    for (let rule of item.validationRules) {
                        if (rule(item.dataItemValue) != true)
                            return false;
                    }
                    return true;
                }
                let items = this.getCurrentPageItems();
                for (let item of items.filter(item => item.itemType == 'data-item')) {
                    if (!validate_item(item)) {
                        return false;
                    }
                };
                return true;
            },
            nextButton_onClick: async function () {
                if (!this.validate()) {
                    this.wizSnackbarText = "Form contains error(s), please check";
                    this.wizSnackbarShow = true;
                    return;
                }

                if (!await this.saveFormData())
                    return;

                if (this.wizCurrentPage < this.getLastPageNumber()) {
                    this.setCurrentPage(this.wizCurrentPage + 1);
                } else {
                    if (crfCallbacks[this.crfId] && crfCallbacks[this.crfId].onSubmit) {
                        await crfCallbacks[this.crfId].onSubmit.call(this);
                    } else {
                        let dlg_content = getEndOfFormDialogHtml.call(this);
                        if (dlg_content) {
                            this.showDialog(dlg_content, null);
                        } else {
                            this.formRedirectBusy = true;
                            this.goToURL(this.getNextCrfUrl, 'first');
                        }
                    }
                }
            },
            prevButton_onClick: async function () {
                if (this.getFormHasUnsavedChanges && !this.validate()) {
                    this.wizSnackbarText = "Form contains error(s), please check";
                    this.wizSnackbarShow = true;
                    return;
                }

                if (!await this.saveFormData())
                    return;

                if (this.wizCurrentPage > 1) {
                    this.setCurrentPage(this.wizCurrentPage - 1);
                } else {
                    this.formRedirectBusy = true;
                    this.goToURL(this.getPrevCrfUrl, 'last');
                }
            },
            showDialog: function (message, onCloseDialog) {
                this.dlgMessage = message;
                this.dlgInfo = true;
                this.formSubmitBusy = false;
                this.formSavingBusy = false;
                this.dlgOnClose = onCloseDialog;
            },
            setCurrentPage: function (page_number) {
                this.wizCurrentPage = page_number;
                this.setDefaultPage(page_number);

                //always scroll to Top of displayed items
                this.$vuetify.goTo(".dynamic-crf-wrapper");

                this.nextTick_updateVisibleValidations();
                this.nextTick_focusFirstEditableItem();
                this.nextTick_updateScrollIndicator();
                this.clearErrors();
            },
            nextTick_updateVisibleValidations: function () {
                let self = this;
                this.$nextTick().then(function () {
                    self.$refs.dynamicForm.validate();
                });
            },
            nextTick_focusFirstEditableItem: function () {
                let self = this;
                this.$nextTick().then(function () {
                    let firstVisibleDataItem = self.findFirstEditableDataItem();
                    if (firstVisibleDataItem) {
                        let el = self.$refs[firstVisibleDataItem.dataItemId][0];
                        if (typeof el.focus === "function") {
                            el.focus();
                        }
                    }
                });
            },
            nextTick_updateScrollIndicator: function () {
                let self = this;
                this.$nextTick().then(function () {
                    let lhs = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight;
                    let rhs = document.documentElement.offsetHeight - 45;

                    self.showScrollIndicator = lhs < rhs;
                });
            },
            saveFormData: async function () {
                try {
                    let dataTableID = this.crfId;
                    let crf = this.crfs[dataTableID];
                    this.formSubmitBusyText = "Please wait, saving form data";
                    this.formSavingBusy = true;
                    let formSavedStatus = 0;

                    if (!crf.isOnboarding) {
                        let dataItems = [];
                        this.getCurrentPageItems().filter(item => item.itemType == 'data-item').forEach(item => {
                            dataItems.push({
                                dataItemId: item.dataItemId,
                                dataItemValue: this.cleanDataItemValue(item.dataItemValue),
                            });
                        });

                     formSavedStatus=(await axios.post(`${this.baseUrl}SaveFormData`, {
                            guid: this.getFormGuid,
                            tableName: dataTableID,
                            timePointDataItem: crf.timePointDataItem,
                            sessionRestoreInfo: JSON.stringify({
                                lastEditedURL: this.$route.path,
                                lastEditedItem: dataItems[0] ? dataItems[0].dataItemId : undefined
                            }),
                            dataItems,
                            pin: this.getDataEntryPin,
                        })).data;
                    } else {
                        let newData = {};
                        crf.dataItems.filter(item => item.itemType == 'data-item').forEach(item => {
                            newData[item.dataItemId] = item.dataItemValue;
                        });
                        this.setOnboardingFormData({ dataTableID, newData });
                    }
                    this.setFormHasUnsavedChanges(false);

                    this.formSubmitBusy = false;
                    this.formSavingBusy = false;
                                       
                    if (formSavedStatus === -6) {//PIN has expired
                        this.resetDataEntry();
                        return this.$router.push("/session-expired-message");
                    }                    
                    return true;

                } catch (error) {
                    this.setFormHasUnsavedChanges(false);
                    this.dlgMessage = `Sorry, we are having some technical issues. Please email ${trialResourceAccount} quoting error description: ${this.crfs[
                        this.crfId
                    ].crfTitle.toUpperCase()}-FAILED-TO-SAVE`;
                    this.dlgInfo = true;
                    this.formSubmitBusy = false;
                    this.formSavingBusy = false;
                    return false;
                }
            },
            setFormData: async function () {
                let dataTableID = this.crfId;
                let crf = this.crfs[dataTableID];

                this.formSubmitBusyText = "Please wait, loading form data";
                this.formSubmitBusy = true;

                this.dlgInfoOrigion = "form-data-loading";

                let dataItemValues;
                try {
                    if (!crf.isOnboarding) {
                        let rData = await axios.post(`${this.baseUrl}GetFormData`, {
                            guid: this.getFormGuid,
                            tableName: dataTableID,
                            timePointDataItem: this.crfs[dataTableID].timePointDataItem,
                            pin: this.getDataEntryPin
                        });
                        dataItemValues = rData.data;
                    } else {
                        let data = this.getOnboardingFormData[dataTableID];
                        dataItemValues = data ? data : {};
                    }
                } catch (error) {
                    this.dlgMessage = `Sorry, we are having some technical issues. Please email ${trialResourceAccount} quoting error description: ${this.crfs[
                        this.crfId
                    ].crfTitle.toUpperCase()}-FAILED-TO-INITIALISE-FORM`;
                    this.dlgInfo = true;
                    return;
                }

                //update crf data object
                crf.dataItems.filter(item => item.itemType == "data-item").forEach(item => {
                    item.dataItemValue = dataItemValues[item.dataItemId];
                });

                //apply skip logic
                this.applySkipLogic();
                this.customSkipLogic();

                this.formSubmitBusy = false;
            },
            clearCustomError: function () {
                this.pinErrorMessage = "";
                this.pinError = false;
            },
            displayCrfTitle: function () {
                this.setCrfTitle(this.crfTitle);
            },
            updateTimepointText,
            clearCustomErrorC: function () {
                this.pinErrorMessageC = "";
                this.pinErrorC = false;
            },
            dataItemChanged: async function (dataItemId, dataItemValue) {
                //Initial screen alerts
                this.wizSnackbarColor = "error";
                this.wizSnackbarStacked = false;

                this.applySkipLogic();
                this.customSkipLogic();

                this.rebuildPages();
                this.calculateFormCompleteness();

                this.setFormHasUnsavedChanges(true);

                this.nextTick_updateVisibleValidations();
            },
            dataItemOnBlur: function (dataItemId, dataItemValue) {
                //Initial screen alerts
                this.wizSnackbarColor = "error";
                this.wizSnackbarStacked = false;
            },
            customSkipLogic: function () {
            },
            applySkipLogic,
            calculateFormCompleteness: function () {
                let qCount = 0, vCount = 0;
                this.crfs[this.crfId].dataItems.forEach(item => {
                    if (item.itemType == "data-item" && !item.missingDataExclude) {
                        if (item.controlEnabled) {
                            qCount++;
                            if (item.dataItemValue || item.dataItemValue === 0) {
                                vCount++;
                            }
                        }
                    }
                })
                this.formCompleteness = `${Math.round((vCount / qCount) * 100)}%`;
                this.setFormCompleteness(this.formCompleteness);
            },
            closeInfoDialog: function () {
                if (this.dlgOnClose) {
                    let on_close = this.dlgOnClose;
                    this.dlgOnClose = null;
                    this.dlgInfo = false;
                    on_close();
                } else if (this.dlgInfoOrigion == "form-data-saved") {
                    this.formRedirectBusy = true;
                    this.$router.push(this.getNextCrfUrl);
                } else if (this.dlgInfoOrigion == "form-data-loading") {
                    this.$router.push("/");
                }
            },
            requiredRule: (v) => {
                if (v) v = v.toString().trim();
                if (v === 0 || !!v) return true;
                else return "This is required";
            },
            ageCheckRule: (v, minAge, maxAge) => {
                //note: date erorr messages come from a hack in the date picker control, not here.
                //this validation is purely for the check before going to the next page.
                //todo: integrate this properly.
                if (!v) return true;
                let currentAge = moment().diff(v, "years");
                if (currentAge > 120)
                    return `Age calculated (${currentAge}) must be less or equal to 120 years`;
                else if (minAge && maxAge) {
                    if (currentAge < minAge || currentAge > maxAge)
                        return `Age calculated (${currentAge}) must be between ${minAge} and ${maxAge} years`;
                } else if (minAge) {
                    if (currentAge < minAge)
                        return `Age calculated (${currentAge}) must be greater or equal to ${minAge} years`;
                } else if (maxAge) {
                    if (currentAge > maxAge)
                        return `Age calculated (${currentAge}) must be less or equal to ${maxAge} years`;
                }
                return true;
            },
            emailRule: (v) => {
                if (v) {
                    v = v.toString().trim();
                    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v)) {
                        return true;
                    } else {
                        return "E-mail must be valid";
                    }
                } else {
                    return true;
                }
            },
            nameRule: (v) => {
                if (v) {
                    v = v.toString().trim();
                    if (/^( ?[a-zA-Z]+([-_'.][a-zA-Z]+)*)+$/.test(v)) {
                        return true;
                    } else {
                        return "Must be a valid name format";
                    }
                } else {
                    return true;
                }
            },
            postcodeRule: (v) => {
                if (v) {
                    v = v.toString().trim();
                    if (/^(([gG][iI][rR] 0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkpstuwA-HJKPSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) [0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/.test(v)) {
                        return true;
                    } else {
                        return "Must be valid UK postcode";
                    }
                } else {
                    return true;
                }
            },
            phoneNumberRule: (v) => {
                if (v) {
                    v = v.toString().trim();
                    if (/^\(\(?(020[7,8]{1}\)?[ ]?[1-9]{1}[0-9{2}[ ]?[0-9]{4})|(0[1-8]{1}[0-9]{3}\)?[ ]?[0-9]{3}[ ]?[0-9]{3})$/.test(v)) {
                        return true;
                    } else {
                        return "Must be valid UK mobile phone number";
                    }
                } else {
                    return true;
                }
            },
            numberRule: (v) => {
                if (v) {
                    v = v.toString().trim();
                    if (/^\d+$/.test(v)) {
                        return true;
                    } else {
                        return "Number could be up to 10 digits";
                    }
                } else {
                    return true;
                }
            },
            decimalRule: (v) => {
                if (v) {
                    v = v.toString().trim();
                    if (/^(\d+(\.\d{0,2})?|\.?\d{1,2})$/.test(v)) {
                        return true;
                    } else {
                        return "Number could be up to 10 digits with optional 2 decimal places";
                    }
                } else {
                    return true;
                }
            },
            tinyintRule: (v) => {
                if (v) {
                    v = v.toString().trim();
                    if (/^\d+$/.test(v) && v >= 0 && v <= 255) {
                        return true;
                    } else {
                        return "Number must be between 0 and 255";
                    }
                } else {
                    return true;
                }
            },
            smallintRule: (v) => {
                if (v) {
                    v = v.toString().trim();
                    if (/^\d+$/.test(v) && v >= -32768 && v <= 32767) {
                        return true;
                    } else {
                        return "Number must be between -32768 and 32767";
                    }
                } else {
                    return true;
                }
            },
            intRule: (v) => {
                if (v) {
                    v = v.toString().trim();
                    if (/^\d+$/.test(v) && v >= 0 && v <= 2147483647) {
                        return true;
                    } else {
                        return "Number must be between 0 and 2147483647";
                    }
                } else {
                    return true;
                }
            },
            numberRangeRule: (v, min, max) => {
                if (v) {
                    v = v.toString().trim();
                    if (v >= min && v <= max) {
                        return true;
                    } else {
                        return `Number must be between ${min} and ${max}`;
                    }
                } else {
                    return true;
                }
            },
            regExpRule: (v, expression, errorMsg) => {
                if (v) {
                    v = v.toString().trim();
                    let re = new RegExp(expression);
                    if (re.test(v)) {
                        return true;
                    } else {
                        return errorMsg;
                    }
                } else {
                    return true;
                }
            },
            applyRequiredWhenEnabledRule: function (cDataItem) {
                if (cDataItem.dataType.includes("date")) {
                    cDataItem.dateIsRequired = true;
                } else if (cDataItem.hasLookUpTable && this.$vuetify.breakpoint.mdAndUp) {
                    //normal Select
                    cDataItem.lookupIsRequired = true;
                    cDataItem.validationRules.push(this.requiredRule);
                } else if (cDataItem.hasLookUpTable && this.$vuetify.breakpoint.smAndDown) {
                    //custom answerOptions component
                    cDataItem.lookupIsRequired = true;
                    cDataItem.validationRules.push(this.requiredRule);
                } else if (cDataItem.dataType == "trialPlaceNames" || cDataItem.dataType == "placeNamesByType") {
                    cDataItem.lookupServiceIsRequired = true;
                    cDataItem.validationRules.push(this.requiredRule);
                } else {
                    cDataItem.validationRules.push(this.requiredRule);
                }
                this.$refs.dynamicForm.validate();
            },
            removeRequiredWhenEnabledRule: function (cDataItem) {
                for (let i = cDataItem.validationRules.length - 1; i >= 0; i -= 1) {
                    if (cDataItem.validationRules[i].name == "bound requiredRule") {
                        cDataItem.validationRules.splice(i, 1);
                    }
                }
                if (cDataItem.dataType.includes("date")) {
                    cDataItem.dateIsRequired = false;
                } else if (cDataItem.hasLookUpTable) {
                    cDataItem.lookupIsRequired = false;
                } else if (cDataItem.dataType == "trialPlaceNames" || cDataItem.dataType == "placeNamesByType") {
                    cDataItem.lookupServiceIsRequired = false;
                }
                this.$refs.dynamicForm.validate();
            },
            cleanDataItemValue: function (value) {
                return value == null ? "" : value;
            },
        },
        computed: {
            ...mapGetters([
                "getFormGuid",
                "getFormAuthenticated",
                "getNextCrfUrl",
                "getPrevCrfUrl",
                "getDataEntryPin",
                "getMenuItemFormCompleteness",
                "getFormHasUnsavedChanges",
                "getStepNotSavedMsg",
                "getMenuItems",
                "getOnboardingFormData",
                "getDefaultPage"
            ]),
            classDynamicCrfQuestionSeparator: function () {
                return {
                    "dynamic-crf-question-separator-md": this.$vuetify.breakpoint.mdAndUp,
                    "dynamic-crf-question-separator-sm": this.$vuetify.breakpoint.smAndDown,
                };
            },
        },
        async mounted() {
            let self = this;

            let dataItemMap = {};
            for (let dataTableID in this.crfs) {
                this.crfs[dataTableID].dataItems.filter(di => di.itemType == 'data-item').forEach(dataItem => {
                    dataItemMap[dataItem.dataItemId] = dataItem;
                });
            };
            this.dataItemMap = dataItemMap;

            this.isMobileMode = this.$vuetify.breakpoint.smAndDown;

            this.setCurrentRoutePath(this.$route.path);

            for (let field in customValidation) {
                this.dataItemMap[field].validationRules.push(customValidation[field]);
            }

            await this.setFormData();

            this.updateTimepointText();

            this.rebuildPages();

            this.calculateFormCompleteness();

            function calcDefaultPageNumber(item_id) {
                switch (item_id) {
                    case 'first':
                        return 1;
                    case 'last':
                        return self.getLastPageNumber();
                    default:
                        //find page containing item_id
                        let found = self.newPages.findIndex(page => page.find(item => item.dataItemId == item_id));
                        return found >= 0 ? found + 1 : 1;
                }
            }

            this.setCurrentPage(calcDefaultPageNumber(this.getDefaultPage));
            this.setDefaultPage('first');

            this.displayCrfTitle();

            window.onscroll = function () {
                self.nextTick_updateScrollIndicator();
            }
        },
    };
</script>
<style>
    .dynamic-crf-question-label {
        padding-left: 10px;
        padding-right: 10px;
        color: #424040;
        font-weight: normal;
        font-size: 1.25rem;
    }

    .dynamic-crf-question-answer-options {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .dynamic-crf-nav-wrapper {
        display: flex;
        justify-content: space-between;
    }

    .dynamic-crf-section-instruction {
        background-color: #ecf6fe;
        min-height: 50px;
        padding: 10px;
        border-radius: 5px;
    }

    .dynamic-crf-question-wrapper {
        max-width: 1200px;
        margin: 0 auto;
        overflow-y: auto;
    }

    .dynamic-crf-question-separator-md {
        border-bottom: 1px solid #e6e6e6;
    }

    .dynamic-crf-question-separator-sm {
        border-bottom: none;
    }

    .dynamic-crf-dialog-text {
        color: #595959;
    }

    .dynamic-crf-info-dialog-text {
        padding-top: 10px;
        color: #212121;
    }
    /* .dynamic-crf-wrapper .v-input--is-disabled fieldset {
      background-color: #f2f2f2;
    } */

    .dynamic-crf-wrapper .v-input--is-disabled .v-input__control {
        background-color: #f2f2f2;
    }

    .dynamic-crf-wiz-wrapper {
        overflow-y: auto;
    }

    .dynamic-crf-footer-btn {
        width: 115px;
        height: 32px !important; /* override vuetify */
    }
</style>
